import { render, staticRenderFns } from "./PlasticMaterials.vue?vue&type=template&id=69ae6fab&scoped=true&"
import script from "./PlasticMaterials.vue?vue&type=script&lang=js&"
export * from "./PlasticMaterials.vue?vue&type=script&lang=js&"
import style0 from "./PlasticMaterials.vue?vue&type=style&index=0&id=69ae6fab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ae6fab",
  null
  
)

export default component.exports